import { Role, RoleFormData, RoleStatus } from "../types"
import { ID, PaginationResult } from "@/types/common"
import type { components } from "@/types/api"
import { createCrudApi } from "@/utils/apiFactory"

type CreateRoleDto = components["schemas"]["CreateRoleDto"]
type UpdateRoleDto = components["schemas"]["UpdateRoleDto"]

const baseApi = createCrudApi<Role, CreateRoleDto, UpdateRoleDto>("/roles")

// 角色API
const roleApi = {
  // 查询所有（支持分页参数）
  async getList(params?: {
    page?: number
    pageSize?: number
  }): Promise<PaginationResult<Role>> {
    return baseApi.list(params)
  },

  // ID查询 - 404 返回 null，其他错误继续抛出
  async getById(id: ID): Promise<Role | null> {
    return baseApi.getById(id)
  },

  // 创建
  async create(data: RoleFormData): Promise<void> {
    const payload: CreateRoleDto = {
      name: data.name,
      code: data.code,
      note: data.note,
    }
    await baseApi.create(payload)
  },

  // 更新
  async update(id: ID, data: RoleFormData): Promise<void> {
    const payload: UpdateRoleDto = {
      name: data.name,
      code: data.code,
      note: data.note,
      status: data.status ?? RoleStatus.ACTIVE,
    }
    await baseApi.update(id, payload)
  },

  // 删除（统一使用数组参数，支持单个和批量）
  async delete(ids: ID[]): Promise<void> {
    await baseApi.delete(ids)
  },
}

export default roleApi
